import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  SearchSelectedUser: {},
};

export const ChatSlice = createSlice({
  name: "ChatSlice",
  initialState,
  reducers: {
    UpdatedSelectedUser: (state, action) => {
      state.SearchSelectedUser = action.payload;
    },
  },
});

export const { UpdatedSelectedUser } = ChatSlice.actions;
export default ChatSlice.reducer;
